/**
 * @fileoverview Hook Actions Layer para gestión de cambio de estado de entrega de órdenes en Inbox.
 * Reuses Orders module hook for a single implementation.
 */
import useOrderDeliveryStatus from '../../../modules/Orders/hooks/useOrderDeliveryStatus';

export default function useCustomerOrderDeliveryStatusActions(order, updateOrderInList) {
  return useOrderDeliveryStatus(order, updateOrderInList);
}
